export const mapOvertimeApprovalDto = (dto) => ({
    id: dto.id,
    userId: dto.user_id,
    dailyWorkRecordId: dto.daily_work_record_id ?? null,
    date: dto.date,
    plannedMinutes: dto.planned_minutes,
    actualMinutes: dto.actual_minutes,
    overtimeMinutes: dto.overtime_minutes,
    approvalStatus: dto.approval_status ?? 'pending',
    displayName: dto.user_name ?? null,
    rejectionReason: dto.rejection_reason ?? null,
});
